// extracted by mini-css-extract-plugin
export var askAiIcon = "_kj-9";
export var container = "_kj-0";
export var groupSeparator = "_kj-a";
export var highlight = "_kj-4";
export var resultIcon = "_kj-5";
export var resultItem = "_kj-7";
export var resultSubtitle = "_kj-3";
export var resultTitle = "_kj-2";
export var resultsList = "_kj-1";
export var searchGroup = "_kj-6";
export var selected = "_kj-8";